import React, { useState, useEffect } from 'react';
import './Team.css';
import Footer from './Footer';

function Team() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setSubmitMessage('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitMessage('');

    try {
      // Formspree - no backend needed!
      const response = await fetch('https://formspree.io/f/xzdgeowv', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          firstName: formData.firstName,
          lastName: formData.lastName,
          email: formData.email,
          _subject: `New Contact Form Submission from ${formData.firstName} ${formData.lastName}`,
          _source: 'Team Page'
        }),
      });

      if (response.ok) {
        setSubmitMessage('Thank you for your interest! We will be in touch soon.');
        setFormData({ firstName: '', lastName: '', email: '' });
      } else {
        setSubmitMessage('Sorry, there was an error sending your message. Please try again or email us directly.');
      }
    } catch (error) {
      console.error('Error:', error);
      setSubmitMessage('Sorry, there was an error sending your message. Please try again or email us directly.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const teamMembers = [
    {
      name: 'Kinga Egyud',
      title: 'Client Services Director',
      description: 'Swiss-trained hospitality strategist with a background in major international projects across the Middle East and Europe. Kinga advises investors and operators on guest-experience strategy, brand integration, and the creation of refined hospitality concepts that blend commercial intelligence with emotional impact.',
      image: '/img/team/IMG_0185.webp'
    },
    {
      name: 'Matt Di Giorgio',
      title: 'Business Development Director',
      description: 'Entrepreneur and strategic advisor with over two decades of leadership across business development, venture creation, and capital partnerships. Matt bridges commercial insight with relationship-driven representation, supporting growth and expansion across hospitality, sports, and lifestyle sectors.',
      image: '/img/team/matt2.webp'
    },
    {
      name: 'Elisa Graham',
      title: 'Operations Director',
      description: 'Sports hospitality and events professional with extensive experience leading premium programmes for global rights-holders and brands. Elisa\'s expertise lies in strategy, project planning, and budget management — delivering tailored experiences that align creative vision with operational excellence.',
      image: '/img/team/WhatsApp+Image+2025-10-20+at+11.00.27.webp'
    }
  ];

  return (
    <div className="team">
      <div className="container">
        <div className="section-header">
          <span className="section-tag">Team</span>
          <h2 className="section-title">Meet Our Team</h2>
        </div>

        <div className="team-grid">
          {teamMembers.map((member, index) => (
            <div key={index} className="team-member">
              <div className="member-image">
                <img src={member.image} alt={member.name} />
              </div>
              <div className="member-info">
                <h3>{member.name}</h3>
                <p className="member-title">{member.title}</p>
                <p className="member-description">{member.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="team-values">
          <div className="value-item">
            <h3>Precision.</h3>
          </div>
          <div className="value-item">
            <h3>Expertise.</h3>
          </div>
          <div className="value-item">
            <h3>Trust.</h3>
          </div>
        </div>

        <div className="team-contact-section">
          <div className="section-header">
            <h2 className="section-title">Connect with us</h2>
          </div>

          <div className="team-contact-content">
            <div className="team-contact-info">
              <div className="info-item">
                <h3>Locations</h3>
                <p>London · Geneva · Dubai · Rabat</p>
              </div>
              <div className="info-item">
                <h3>Email</h3>
                <a href="mailto:hello@esmehc.com">hello@esmehc.com</a>
              </div>
              <div className="team-contact-image">
                <img src="/img/img-gallery2.webp" alt="Contact" />
              </div>
            </div>

            <div className="team-contact-form-container">
              <form className="team-contact-form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="teamFirstName">First Name</label>
                  <input
                    type="text"
                    id="teamFirstName"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="teamLastName">Last Name</label>
                  <input
                    type="text"
                    id="teamLastName"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="teamEmail">Email Address</label>
                  <input
                    type="email"
                    id="teamEmail"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>

                <button 
                  type="submit" 
                  className="submit-btn"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Sending...' : 'Connect with us'}
                </button>
                {submitMessage && (
                  <p style={{ 
                    marginTop: '15px', 
                    color: submitMessage.includes('error') ? '#d32f2f' : '#2e7d32',
                    fontSize: '14px'
                  }}>
                    {submitMessage}
                  </p>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Team;
